// @flow

import _ from 'lodash';
import React from 'react';

import { Tracking } from 'web-core/src/tracking';

type NavLinkType = {
  event: string,
  eventProps: string,
  link: string,
  shouldAlwaysDisplay: boolean,
  text: string,
};

type Props = {
  commonTranslations: TranslationType,
  isLoggedIn: boolean,
  isPartner: boolean,
  logout: Function,
  navlinks: string, // JSON pass from pug. convert navLinks to navlinks
};

const HomeNav = (props: Props) => {
  const { commonTranslations, isLoggedIn, isPartner, logout } = props;
  const navLinks: Array<NavLinkType> = JSON.parse(props.navlinks);

  const logNavItemClick = (eventName, property) => {
    Tracking.track(eventName, JSON.parse(property));
  };

  const renderNavListItems = () =>
    _.map(navLinks, (navLink) => {
      if (isPartner && navLink.shouldAlwaysDisplay === false) return null;
      return (
        <li key={navLink.text}>
          <a href={navLink.link} onClick={() => logNavItemClick(navLink.event, navLink.eventProps)}>
            {navLink.text}
          </a>
        </li>
      );
    });

  const renderLoginOrLogout = () => {
    if (isLoggedIn) {
      return (
        <li key={commonTranslations.logout}>
          <a href="/" className="logout" onClick={() => logout()}>
            <span className="glyph-logout hide-glyph-for-large-up pad-half-right" />
            <span className="log-in-and-log-out">{commonTranslations.logout}</span>
          </a>
        </li>
      );
    }
    return (
      <li key={commonTranslations.login}>
        <a href="/login">
          <span className="glyph-login hide-glyph-for-large-up pad-half-right" />
          <span className="log-in-and-log-out">{commonTranslations.login}</span>
        </a>
      </li>
    );
  };

  return (
    <nav id="site-header-nav">
      <ul className="inline-block-list small-text-center medium-text-right">
        {renderNavListItems()}
        {renderLoginOrLogout()}
      </ul>
    </nav>
  );
};

export default HomeNav;
